<br />
<p-accordion
  [activeIndex]="activeIndex"
  class="md:w-full block h-full">
  <p-accordionTab
    headerStyleClass="bg-white text-primary border-primary border-[1px]"
    iconPos="end">
    <ng-template pTemplate="header">
      <span class="flex align-items-center gap-2 w-full">
        <!-- <img
          src="assets/common/icons/receipt_long.svg"
          alt="logo-devis" /> -->
        <app-svg-icon
          src="assets/common/icons/receipt_long.svg"
          class="stroke-primary">
        </app-svg-icon>
        <span>{{ "quotation.title" | translate }}</span>
      </span>
    </ng-template>
    <div
      *ngIf="quotations.length === 0; else quotationsList"
      class="bg-lightest flex flex-col items-center p-4 font-app-regular text-darkest rounded-sm">
      <div class="p-2 rounded-sm">
        <p class="text-center">
          {{ "quotation.noQuotationsMessageTitle" | translate }}
        </p>
        <p class="text-center mt-2">
          {{ "quotation.noQuotationsMessageText" | translate }}
        </p>
      </div>
    </div>
    <ng-template #quotationsList>
      <div
        class="cursor-pointer bg-lightest rounded p-3 mb-1 font-app-light min-h-full min-w-full hover:border-primary border-transparent border-[1px] flex flex-col gap-2"
        *ngFor="let quotation of quotations"
        (click)="navigateToDetails(quotation.id)"
        (keydown)="onKeyDown($event, quotation.id)">
        <div class="flex justify-between">
          <app-address-mrh
            *ngIf="isBranchMrh(quotation)"
            [bgLogo]="'bg-white'"
            [colorLogo]="'text-primary'"
            [data]="quotation"></app-address-mrh>

          <app-title-pj
            *ngIf="isBranchPJ(quotation)"
            [bgLogo]="'bg-white'"
            [colorLogo]="'primary'"></app-title-pj>

          <app-title-sa
            *ngIf="isBranchSA(quotation)"
            [bgLogo]="'bg-white'"
            [colorLogo]="'primary'"
            [animalName]="quotation.animalName"></app-title-sa>
          <app-status-card
            *ngIf="quotation"
            [status]="getCustomStatus(quotation)"
            [statusConfig]="quotationStatusConfig"
            class="justify-end"></app-status-card>
        </div>

        <app-quotation-card [quotationMember]="quotation"></app-quotation-card>
      </div>
    </ng-template>
  </p-accordionTab>
</p-accordion>
